import type { CurationPriorReview } from '@avisoma/shared';
import { formatDateOnly } from '../../lib/dateFormat';

// Amber notice surfacing that this page was already reviewed, so a curator sees a
// prior verdict before casting their own (DR-1736). The server sends at most 3,
// most recent first, and only when the page actually has a prior review.
export function PriorReviewsBanner({ reviews }: { reviews: CurationPriorReview[] }) {
  if (reviews.length === 0) return null;

  return (
    <div className="rounded-lg bg-amber-50 p-3 text-sm text-amber-800 ring-1 ring-amber-200/60 dark:bg-amber-900/30 dark:text-amber-300 dark:ring-amber-700/40">
      <ul className="space-y-1">
        {reviews.map((review, index) => (
          <li key={index}>{describe(review)}</li>
        ))}
      </ul>
    </div>
  );
}

const label = (category: string | null) => (category ? `'${category}'` : 'uncategorized');

function describe(review: CurationPriorReview): string {
  // Null name means the requester isn't an admin/supervisor — the peer reviewer's
  // identity is withheld (server-side), so show a neutral label instead of the raw id.
  const who = review.reviewerName ?? 'another reviewer';
  const when = formatDateOnly(review.createdAt);
  const action =
    review.verdict === 'confirmed'
      ? `Previously confirmed as ${label(review.oldCategory)}`
      : `Previously corrected from ${label(review.oldCategory)} to ${label(review.newCategory)}`;
  return `${action} by ${who} on ${when}`;
}
